import lazySensors from '@/plugins/sensors';

const Stat = await lazySensors();

export default Stat;
